// import { persistReducer } from 'redux-persist';
// import createStorage from 'redux-persist/lib/storage';

import { combineReducers } from '@reduxjs/toolkit';
import agentConfigSlice from 'ducks/agentConfig/agentConfigSlice';
import authSlice from 'ducks/auth/authSlice';
import callPanelSlice from 'ducks/callPanel/callPanelSlice';
import chatSlice from 'ducks/chat/chatSlice';
import chatPanelSlice from 'ducks/chatPanel/chatPanelSlice';
import editVariantManagementPanelSlice from 'ducks/editPanel/editPanelSlice';
import eventSourcingFunctionTestPanel from 'ducks/eventSourcingFunctionTestPanel/functionTestPanelSlice';
import functionsFormSlice from 'ducks/functionsForm/functionsFormSlice';
import functionTestPanelSlice from 'ducks/functionTestPanel/functionTestPanelSlice';
import LogPanelSlice from 'ducks/LogPanel/LogPanelSlice';
import layoutSlice from 'ducks/layout/layoutSlice';
import pageStatusSlice from 'ducks/pageStatus/pageStatusSlice';
import projectSlice from 'ducks/project/projectSlice';
import scenariosPanelSlice from 'ducks/scenariosPanel/scenariosPanelSlice';
import tableSlice from 'ducks/table/tableSlice';
import testAgentSlice from 'ducks/testAgent/testAgentSlice';
import testAssistantSlice from 'ducks/testAssistantSlice/testAssistantSlice';
import uploadPanelSlice from 'ducks/uploadPanel/uploadPanelSlice';

import { sliceReducers } from '@polyai/stream/store';

import conflictResolutionSlice from 'store/reducers/conflict-resolution';
import streamTrackerSlice from 'store/reducers/stream-tracker';

// import createIdbStorage from 'store/middleware/createIdbStorage';

const rootReducer = combineReducers({
  streamTracker: streamTrackerSlice,
  conflictResolution: conflictResolutionSlice,
  agentConfig: agentConfigSlice,
  auth: authSlice,
  callPanel: callPanelSlice,
  chatPanel: chatPanelSlice,
  scenariosPanel: scenariosPanelSlice,
  LogPanel: LogPanelSlice,
  functionsForm: functionsFormSlice,
  layout: layoutSlice,
  pageStatus: pageStatusSlice,
  project: projectSlice,
  table: tableSlice,
  testAgent: testAgentSlice,
  testAssistant: testAssistantSlice,
  uploadPanel: uploadPanelSlice,
  editVariantManagementPanel: editVariantManagementPanelSlice,
  chat: chatSlice,
  functionTestPanel: functionTestPanelSlice,
  eventSourcingFunctionTestPanel: eventSourcingFunctionTestPanel,
  ...sliceReducers,
});

// const isBrowser = typeof window !== 'undefined' && 'indexedDB' in window;

// const persist = persistReducer(
//   {
//     key: 'root',
//     // Should probably save undoable here, check with Elvis if you are reading this
//     whitelist: [...Object.keys(sliceReducers), 'streamTracker'],
//     serialize: false,
//     // @ts-expect-error
//     deserialize: false,
//     debug: true,
//     storage: isBrowser
//       ? createIdbStorage({
//           name: 'streamdb',
//           version: 1,
//           storeName: 'stream_snapshot',
//         })
//       : createStorage,
//   },
//   rootReducer,
// );

export default rootReducer;
